import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../environments/environment';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { CognitoUtil } from './cognito.service';
import { AccountManagement } from '../app/models/account-management';
import { CognitoChangeRequestTo } from '../app/models/cognito-change-request-to';
import { CognitoChangeRequestFrom } from '../app/models/cognito-change-request-from';
import { Boolean } from 'aws-sdk/clients/emr';
import { AccountManagementInterface } from 'app/interface/accountManagement';
import { SmarthomeOccupantInterface } from 'app/interface/smarthomeOccupant';
import {SmarthomeOccupant} from '../app/models/smarthomeoccupant';
import {map, catchError} from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable()
export class AccountService {
    public static _API_ENDPOINT = environment.apiEndPoint;

    constructor(private http: HttpClient, private router: Router, private cognitoUtil: CognitoUtil) { }

    createOptions() {
        this.cognitoUtil.refresh();
        return {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': localStorage.getItem('AWSCreds'),
                'Identity': localStorage.getItem('CognitoId'),
                'Sub': localStorage.getItem('CognitoSub')
            })
        };
    };

    getAccountManagementInfo() {
        return this.http.get(AccountService._API_ENDPOINT + 'Account/GetAccountManagementInfo', this.createOptions()).pipe(
            catchError(this.handleError),
            map((response) => <AccountManagement>(response)));
    }

    cancelCognitoRequest(request: CognitoChangeRequestTo) {
        return this.http.post(AccountService._API_ENDPOINT + 'Account/CancelCognitoChangeRequest', request,
            this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <Boolean>(response))
            );
    }

    denyCognitoRequest(request: CognitoChangeRequestFrom) {
        return this.http.post(AccountService._API_ENDPOINT + 'Account/DenyCognitoChangeRequest', request,
            this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <Boolean>(response))
            );
    }

    acceptCognitoRequest(request: CognitoChangeRequestFrom) {
        return this.http.post(AccountService._API_ENDPOINT + 'Account/AcceptCognitoChangeRequest', request,
            this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <string>(response))
            );
    }

    getSmarthomeUserStatus() {
        return this.http.get(AccountService._API_ENDPOINT + 'Account/UserHasSmartHomeAccess', this.createOptions())
        .pipe(
            catchError(this.handleError),
            map((response) => <SmarthomeOccupant>(response))
        );
    }

    getBeHomeResidentUrl() {
        return this.http.get(AccountService._API_ENDPOINT + 'Account/RequestBeHomeUrl', this.createOptions())
        .pipe(
            catchError(this.handleError),
            map((response) => (response))
        );;
    }

  /**
   * @deprecated Use getResidentStatus2
   */
  getResidentStatus() {
        return this.http.get(AccountService._API_ENDPOINT + 'Account/GetResidentStatus', this.createOptions())
        .pipe(
            catchError(this.handleError),
            map((response) => (response))
        );;
    }

  getResidentStatus2() {
      return this.http.get(AccountService._API_ENDPOINT + 'Account/GetResidentStatus', this.createOptions())
          .pipe(
              catchError(err => {
                return throwError("Error determining Resident status.\nPlease contact Tricon Support for help.")
              }
          ),
          map(res => <boolean>res)
      );
  }

    requestEmailReminder = (phoneNumber: string) => {
        return this.http.post(AccountService._API_ENDPOINT + 'Account/RequestEmailReminder', JSON.stringify(phoneNumber), {headers: new HttpHeaders({
            'Content-Type': 'application/json'})})
        .pipe(
            catchError(this.handleError),
            map((response) => (response))
        );;
    }

    handleError(error: HttpErrorResponse) {
        let errMsg: string;
        if (error.status === 403) {
            this.router.navigate(['/logout']);
        }
        if (error.error  instanceof ErrorEvent) {
            const body = error.error;
            if (body.message) {
                errMsg = error.error.message;
            } else {
                const err = body;
                errMsg = `${error.statusText || ''} ${err}`;
            }
        } else {
            errMsg = error.message ? error.message : error.toString();
            if (errMsg.length === 0) {
                errMsg = 'There was an unknown error.  Please try again later';
            }
        }
        return errMsg;
    }

}
